import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Paper,
  Stack,
  TextField,
  Checkbox,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Skeleton,
  Grid,
  Switch,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";
import SyncLoader from "react-spinners/SyncLoader";
import { Select, InputLabel } from "@mui/material";
import { openInNewTabWithFallback } from "../../../utils/newTabOpener";


const MockTest = () => {
  const detailObject = JSON.parse(localStorage.getItem("detailObject"));
  const accessArr = detailObject?.access_level?.split(",");
  const role = localStorage.getItem("role");
  const [isLive, setIsLive] = useState("false");
  const [isFree, setIsFree] = useState("");
  const navigate = useNavigate();

  const getCacheKey = (p, r, f) => {
    const fStr = JSON.stringify(f || {}).replace(/[^a-zA-Z0-9]/g, "");
    return `mocktest_cache_${p}_${r}_${fStr}`;
  };

  const [mocktest, setMockTest] = useState(() => {
    try {
      const cached = localStorage.getItem("mocktest_cache_1_5_");
      if (cached) {
        const parsed = JSON.parse(cached);
        return parsed.data || [];
      }
    } catch (e) {}
    return [];
  });

  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  
  const [loading, setLoading] = useState(() => {
    try {
      const cached = localStorage.getItem("mocktest_cache_1_5_");
      return !cached;
    } catch (e) {
      return true;
    }
  });

  const [total, setTotal] = useState(() => {
    try {
      const cached = localStorage.getItem("mocktest_cache_1_5_");
      if (cached) {
        const parsed = JSON.parse(cached);
        return parsed.total || 0;
      }
    } catch (e) {}
    return 0;
  });

  const token = localStorage.getItem("token");
  const [exams, setAllExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(""); // Store selected status
  const [selectedMedium, setSelectedMedium] = useState(); // Store selected medium

  // Separate state for filters to trigger API calls
  const [apiFilters, setApiFilters] = useState({
    search: "",
    isLive: "false",
    isFree: "",
    is_active: "",
    medium: "",
    exam_id: "",
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page when rows per page changes
  };

  const handleExamFilterChange = async (event) => {
    setSelectedExam(event.target.value); // Set the selected exam_id
    // Filter mockTest data based on selected exam
    // await fetchMockTest(1, rowsPerPage, {
    //   ...apiFilters,
    //   exam_id: event.target.value, // Pass exam_id as a filter
    // });

    setApiFilters((prev) => ({ ...prev, exam_id: event.target.value }));
    setPage(0); // Reset to first page when filtering
  };

  const handleStatusFilterChange = (event) => {
    console.log("Status Filter Changed:", event.target.value);
    setSelectedStatus(event.target.value);
    setApiFilters((prev) => ({ ...prev, is_active: event.target.value }));
    setPage(0); // Reset to first page when filtering
  };

  const handleMediumFilterChange = (event) => {
    setSelectedMedium(event.target.value);
    setApiFilters((prev) => ({ ...prev, medium: event.target.value }));
    setPage(0); // Reset to first page when filtering
  };

  const fetchMockTest = async (pageNum = 1, perPage = 5, filters = {}) => {
    const cacheKey = getCacheKey(pageNum, perPage, filters);
    
    // Load from cache first
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        setMockTest(parsed.data || []);
        setTotal(parsed.total || 0);
      }
    } catch (e) {}

    // Only set loading to true if we don't have cached data for this page/filter combination
    const hasCache = localStorage.getItem(cacheKey);
    if (!hasCache) {
      setLoading(true);
    }

    try {
      // Build query parameters
      let url = `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-all-mock-test?page=${pageNum}&limit=${perPage}`;

      // Add search parameter if exists
      if (filters.search) {
        url += `&search=${encodeURIComponent(filters.search)}`;
      }

      // Add filter parameters if exists
      if (filters.isLive) {
        url += `&isLive=${filters.isLive}`;
      }

      if (filters.isFree) {
        url += `&isFree=${filters.isFree}`;
      }

      if (filters.exam_id) {
        url += `&exam_id=${filters.exam_id}`; // Add exam_id to the URL
      }

     if (filters.is_active) {
      url += `&is_active=${filters.is_active}`; // Add is_active to the URL
    }

      if (filters.medium) {
        url += `&medium=${filters.medium}`; // Add medium to the URL
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        const fetchedData = responseData?.data?.data || [];
        const fetchedTotal = responseData?.data?.total || 0;
        
        // Set the data and total count from the API
        setMockTest(fetchedData);
        setTotal(fetchedTotal);

        // Update local cache
        localStorage.setItem(cacheKey, JSON.stringify({
          data: fetchedData,
          total: fetchedTotal
        }));

        console.log("Mock Test Data:", fetchedData);
        toast.success("Mock Test Fetched Successfully");
      } else {
        toast.error("Failed to fetch mock tests");
      }
    } catch (error) {
      console.error("Error fetching mock tests:", error);
      toast.error("Error fetching mock tests");
    }
    setLoading(false);
  };

  // Debounced search function
  const [searchTimeout, setSearchTimeout] = useState(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set new timeout for debounced search
    const timeout = setTimeout(() => {
      setApiFilters((prev) => ({ ...prev, search: value }));
      setPage(0); // Reset to first page when searching
    }, 500); // 500ms delay

    setSearchTimeout(timeout);
  };

  const handleClearFilters = () => {
    setApiFilters({ isLive: "false" });
    setIsLive("false");
    setSearchValue("");
    setSelectedExam("");
    setSelectedStatus("");
    setSelectedMedium("");
    setPage(0);
  };

  const handleLiveFilterChange = (value) => {
    const newValue = isLive === value ? "" : value;
    setIsLive(newValue);
    setApiFilters((prev) => ({ ...prev, isLive: newValue }));
    setPage(0); // Reset to first page when filtering
  };

  const handleFreeFilterChange = (value) => {
    const newValue = isFree === value ? "" : value;
    setIsFree(newValue);
    setApiFilters((prev) => ({ ...prev, isFree: newValue }));
    setPage(0); // Reset to first page when filtering
  };

  // Initial load
  useEffect(() => {
    fetchMockTest(1, rowsPerPage, apiFilters);
    handleFetchAllExam();
  }, []);

  // Fetch data when page, rowsPerPage, or filters change
  useEffect(() => {
    fetchMockTest(page + 1, rowsPerPage, apiFilters);
  }, [page, rowsPerPage, apiFilters]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const currentPageRows = mocktest?.map((user) => user.id);
      setSelectedRows(currentPageRows);
      setSelectAll(true);
    } else {
      setSelectedRows([]);
      setSelectAll(false);
    }
  };

  const handleRowSelect = (userId) => {
    if (selectedRows.includes(userId)) {
      setSelectedRows(selectedRows.filter((id) => id !== userId));
    } else {
      setSelectedRows([...selectedRows, userId]);
    }
  };

  // Reset selection when page changes
  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
  }, [page]);

  const handleDeleteSelected = async () => {
    const token = localStorage.getItem("token");
    console.log([...selectedRows]);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/delete-bulk-mocktest`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ ids: [...selectedRows] }),
        }
      );

      if (res.ok) {
        toast.success("Deleted successfully");
        // Refresh current page data
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
        setSelectedRows([]);
        setSelectAll(false);
      } else {
        toast.error("Failed to delete items");
      }
    } catch (error) {
      console.error("Error deleting items:", error);
      toast.error("Error deleting items");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/delete-mock-test/${selectedRow.id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.ok) {
        toast.success("Deleted successfully");
        // Refresh current page data
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
        handleClose();
      } else {
        toast.error("Failed to delete mock test");
      }
    } catch (error) {
      console.error("Error deleting mock test:", error);
      toast.error("Error deleting mock test");
    }
  };

  const handleCopyMockTest = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/copy-mock-test/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fullres = await res.json();

      if (res.ok) {
        toast.success("Mock Test copied successfully");
        handleEditManualTest(fullres.data.id);
      } else {
        toast.error("Failed to copy Mock Test");
      }
    } catch (error) {
      toast.error("Failed to copy Mock Test");
      console.error("Error copying mock test:", error);
    }
  };

  const [open3, setOpen3] = useState(false);

  const handleClickOpen3 = (index) => {
    setDeleteConfirm(index);
    setOpen3(true);
  };

  const handleClose3 = () => {
    setDeleteConfirm(null);
    setOpen3(false);
  };

  const handleConfirm3 = () => {
    handleDelete();
    handleClose3();
  };

  const changeStatus = async (row) => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const status = await axios.put(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/change-status/${row?.id}`,
        { is_active: row?.is_active == 0 ? 1 : 0 },
        { headers }
      );

      if (status.status === 200) {
        toast.success("Status changed successfully");
        // Refresh current page data
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
      }
    } catch (error) {
      console.error("Error changing status:", error);
      toast.error("Error changing status");
    }
  };

  const handleFetchAllExam = async () => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-all-exam`,
        { headers }
      );

      if (response.status === 200) {
        setAllExams(response?.data?.data || []);
        console.log("All Exams:", response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching all exams:", error);
      toast.error("Error fetching all exams");
    }
  };

  const handleEditManualTest = (testId) => {
    const path = `/dashboard/updateManualTest/${testId}`;
    const result = openInNewTabWithFallback(path, "Manual Test Edit");
    if (!result.success) {
      toast.error("Popup blocked. Please allow pop-ups for this site.");
    }
  };

  const handleEditTemplateTest = (testId) => {
    const path = `/dashboard/updateTemplateTest/${testId}`;
    const result = openInNewTabWithFallback(path, "Template Test Edit");
    if (!result.success) {
      toast.error("Popup blocked. Please allow pop-ups for this site.");
    }
  };

  return (
    <>
      <Page title="Mock Test">
          <Typography className="page-heading">All Mock Test </Typography>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: "16px",
              bgcolor: "#f8fafc",
              border: "1px solid #e2e8f0",
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <TextField
                  label="Search Mock Test"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={searchValue}
                  onChange={handleSearchChange}
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              
              <Grid item xs={12} md={3} display="flex" gap={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isLive === "true"}
                      onChange={(e) => handleLiveFilterChange(e.target.checked ? "true" : "")}
                      color="primary"
                    />
                  }
                  label="Only Live"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={isFree === "true"}
                      onChange={(e) => handleFreeFilterChange(e.target.checked ? "true" : "")}
                      color="primary"
                    />
                  }
                  label="Only Free"
                />
              </Grid>

              <Grid item xs={12} md={5} display="flex" justifyContent="flex-end" gap={2}>
                {selectedRows.length > 0 && (
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={handleDeleteSelected}
                  >
                    Delete Selected ({selectedRows.length})
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="inherit"
                  size="small"
                  onClick={handleClearFilters}
                  sx={{ borderColor: "#cbd5e1" }}
                >
                  Clear Filters
                </Button>
              </Grid>

              <Grid item xs={12} md={5}>
                <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                  <InputLabel>Exam Name</InputLabel>
                  <Select
                    value={selectedExam}
                    onChange={handleExamFilterChange}
                    label="Filter by Exam"
                  >
                    {exams?.map((exam) => (
                      <MenuItem key={exam.id} value={exam.id}>
                        {exam.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} md={3.5}>
                <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                  <InputLabel>Medium</InputLabel>
                  <Select
                    value={selectedMedium || ""}
                    onChange={handleMediumFilterChange}
                    label="Filter by Medium"
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value={1}>English</MenuItem>
                    <MenuItem value={2}>Hindi</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} md={3.5}>
                <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="is_active"
                    value={selectedStatus}
                    onChange={handleStatusFilterChange}
                    label="Filter by Status"
                  >
                    <MenuItem value={"1"}>Publish</MenuItem>
                    <MenuItem value={"0"}>Draft</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>

          <TableContainer
            component={Paper}
            sx={{ width: "100%", overflowX: "auto" }}
          >
            <Table sx={{ tableLayout: "auto" }}>
              <TableHead style={{ backgroundColor: "#e6e6ff" }}>
                <TableRow>
                  {(role == "Admin" || accessArr?.includes("delete")) && (
                    <TableCell padding="checkbox" sx={{ width: 50 }}>
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        indeterminate={
                          selectedRows.length > 0 &&
                          selectedRows.length < mocktest.length
                        }
                      />
                    </TableCell>
                  )}
                  <TableCell sx={{ width: 150 }}>Name</TableCell>

                  <TableCell sx={{ width: 150 }}>Category</TableCell>
                  <TableCell sx={{ width: 150 }}>Exam Name</TableCell>
                  <TableCell sx={{ width: 100 }}>Type</TableCell>
                  <TableCell sx={{ width: 100 }}>Language</TableCell>
                  <TableCell sx={{ width: 150 }}>Duration (mins)</TableCell>
                  <TableCell sx={{ width: 150 }}> Marks</TableCell>
                  <TableCell sx={{ width: 150 }}> Question Count</TableCell>
                  <TableCell sx={{ width: 150 }}>Negative Marks</TableCell>
                  <TableCell sx={{ width: 100 }}>Status</TableCell>
                  <TableCell sx={{ width: 100 }}>Add Ques.</TableCell>
                  <TableCell sx={{ width: 100 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (!mocktest || mocktest.length === 0) ? (
                  Array.from({ length: rowsPerPage }).map((_, i) => (
                    <TableRow key={i}>
                      {(role === "Admin" || accessArr?.includes("delete")) && (
                        <TableCell padding="checkbox">
                          <Skeleton variant="rectangular" width={20} height={20} />
                        </TableCell>
                      )}
                      <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="60%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="70%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="50%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="50%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="60%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                    </TableRow>
                  ))
                ) : (
                  mocktest?.map((user, index) => (
                  <TableRow key={user.id || index}>
                    {(role === "Admin" || accessArr?.includes("delete")) && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(user.id)}
                          onChange={() => handleRowSelect(user.id)}
                        />
                      </TableCell>
                    )}
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.title || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.course}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.exam_name || user?.classes_name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.mock_test_type === 1 ? "Manual" : "Template"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.language === "en" ? "English" : "Hindi"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.duration || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.eachQuestionMarks || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.count || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {user?.nagetiveMarking 
                          ? user?.nagetiveMarks || "N/A"
                          : "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => changeStatus(user)}
                        color={user?.is_active === "0" ? "error" : "success"}
                        variant="outlined"
                      >
                        {user?.is_active === "1" ? "Publish" : "Draft"}
                      </Button>
                    </TableCell>
                    <TableCell>
                      {user?.mock_test_type === 1 && (
                        <Button
                          variant="contained"
                          sx={{
                            minWidth: "100%",
                            maxWidth: "100%",
                            alignSelf: "center",
                            background: "#e6e6ff",
                            color: "black",
                            borderRadius: "20px",
                            "&:hover": { background: " #8080ff" },
                          }}
                          onClick={() => {
                            const path = `/dashboard/mockTest/${user?.title}/${user?.id}/${user?.count}`;
                            const result = openInNewTabWithFallback(path, "Add Questions");
                            if (!result.success) {
                              toast.error("Popup blocked. Please allow pop-ups for this site.");
                            }
                          }}
                        >
                          Add
                        </Button>
                      )}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(event) => {
                          setAnchorEl(event.currentTarget);
                          setSelectedRow(user);
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {(role === "Admin" || accessArr?.includes("write")) && (
                          <MenuItem
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (selectedRow?.mock_test_type === 1) {
                                handleEditManualTest(selectedRow?.id);
                              } else {
                                handleEditTemplateTest(selectedRow?.id);
                              }
                              handleMenuClose();
                            }}
                          >
                            Edit
                          </MenuItem>
                        )}
                        {(role === "Admin" || accessArr?.includes("write")) && (
                          <MenuItem
                            onClick={() => handleCopyMockTest(selectedRow.id)}
                          >
                            Copy Mock Test
                          </MenuItem>
                        )}
                        {(role === "Admin" ||
                          accessArr?.includes("delete")) && (
                          <MenuItem
                            onClick={() => {
                              setOpen3(true);
                            }}
                          >
                            Delete
                          </MenuItem>
                        )}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
              )}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>

          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />

          <Dialog open={open3} onClose={handleClose3}>
            <DialogTitle>{"Confirm Deletion"}</DialogTitle>
            <DialogContent>
              Are you sure you want to Delete the Mocktest?
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleConfirm3()} color="error">
                YES
              </Button>
              <Button onClick={handleClose3} color="primary">
                NO
              </Button>
            </DialogActions>
          </Dialog>
        </Page>
    </>
  );
};

export default MockTest;
